import type { ReactNode, Ref } from 'react'
import type { View } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'

type TAccessibilityHiddenTitleProps = {
  children?: string | number | ReactNode
  ref?: Ref<View>
}

export const AccessibilityHiddenTitle = ({ ref: refToMainContent, children }: TAccessibilityHiddenTitleProps) => {
  return (
    <Typography heading="h1" tabIndex={0} className="sr-only" ref={refToMainContent}>
      {children}
    </Typography>
  )
}
